module.exports = __webpack_public_path__ + "media/images/countrysquared/gi-c48b53ab39dee94db78094fef831281e.svg";